// extracted by mini-css-extract-plugin
module.exports = {"content":"_1yHGM6ChSEJAs0cDDupnh9"};